export default __webpack_public_path__ + "static/Денежный поток 6-c659a8161c2c657ad896c399a8d74d75.jpg";